import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/grid-pattern-icon.svg")